module.exports = __webpack_public_path__ + "img/quote.f34c5a7.svg";